import { render, staticRenderFns } from "./SpacePrice.vue?vue&type=template&id=94af5ea6"
import script from "./SpacePrice.vue?vue&type=script&lang=js"
export * from "./SpacePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports